// History tab — BP-04 (GUI View 1210): the shared RecordHistoryTab with
// module config only (src/blank/tabs/BlankHistory.tsx, H244). The layout,
// read, grouping, order, tenant-zone time and Old → New live there. Do not
// add them back here: src/history/__tests__/historyTabCensus.test.ts fails a
// History tab that hand-rolls them.
import { useMemo } from "react";

import RecordHistoryTab from "../history/RecordHistoryTab";
import { valueLabelsFrom } from "../history/recordHistoryModel";

interface Props {
  invoiceId: number;
  invoiceConfig: any;
}

export default function InvoiceHistory({ invoiceId, invoiceConfig }: Props) {
  const formatValue = useMemo(
    () =>
      valueLabelsFrom({
        status_id: invoiceConfig?.status_list ?? invoiceConfig?.status,
      }),
    [invoiceConfig]
  );
  return (
    <RecordHistoryTab
      sourceType="invoices"
      sourceId={invoiceId}
      noun="invoice"
      formatValue={formatValue}
    />
  );
}
